import { t } from 'services/Translation'

import { KitSize } from '../KitTypes'
import type { IQueryOption } from './types'

export const TABLE_RESET_SEARCH = '?page=1&sort=updatedAt&sortOrder=DESC'
export const MIN_COLUMN_WIDTH = 88

export const isArchived = (defaultValue: boolean | null = false): IQueryOption<boolean | null> => ({
  default: defaultValue,
  toValue: (value) => {
    if (value === 'true') {
      return true
    }

    if (value === 'false') {
      return false
    }

    if (value === null) {
      return null
    }

    return false
  },
})

export const DEFAULT_PAGE_SIZE = 25

export const DEFAULT_EMPTY_CONFIG = {
  search: {
    text: t('common.emptySearch'),
    icon: 'search' as const,
    size: KitSize.S,
  },
  disabled: {
    text: t('common.nothingFound'),
    icon: 'folder' as const,
    size: KitSize.S,
  },
  empty: {
    text: t('common.nothingFound'),
    icon: 'folder' as const,
    size: KitSize.S,
  },
}
